import { Injectable } from '@angular/core';
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {ModalComponent} from "../common/layout/modal/modal.component";
import {HttpHeaders} from "@angular/common/http";
import {Project} from "../models/project.model";
import {Subject} from "rxjs";
import { ProjectSettings } from '../models/datagate/datagate.model';

export const HTTP_HEADERS = new HttpHeaders()
  .set('Accept', 'application/json')
  .set('Access-Control-Allow-Origin', '*');

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  bsModalRef?: BsModalRef;

  public activeProjects: Project[] = [];

  public online = false;

  public errorNotOnline = false;

  public error = '';

  public loading = true;

  public dialogRef: any;

  public title = '';

  public subTitle = '';

  public sidebar =  new Subject<boolean>();

  public thankYouPage = new Subject<boolean>();

  public globalLoading = new Subject<boolean>();

  public isLeadGenerationStep = new Subject<boolean>();

  private sessionToken: string = '';
  private projectShortName: string = '';
  private projectSettings: ProjectSettings | null = null;

  constructor(
    private modalService: BsModalService
  ) {
    this.sidebar.next(true);
    this.thankYouPage.next(false);
    this.globalLoading.next(true);
    this.isLeadGenerationStep.next(false);
  }

  openLoadingModal() {
    const initialState: ModalOptions = {
      initialState: {
        list: [],
        title: 'Modal'
      }
    };
    this.bsModalRef = this.modalService.show(ModalComponent, initialState);
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  setTitle(title: string) {
    this.title = title;
  }

  getTitle() {
    return this.title;
  }

  setSubTitle(subTitle: string) {
    this.subTitle = subTitle;
  }

  getSubTitle() {
    return this.subTitle;
  }

  disableSidebar() {
    this.sidebar.next(false);
  }
  enableSidebar() {
    this.sidebar.next(true);
  }
  disableThankYouPage() {
    this.thankYouPage.next(false);
  }
  enableThankYouPage() {
    this.thankYouPage.next(true);
  }

  enableGlobalLoading() {
    this.globalLoading.next(true);
  }

  disableGlobalLoading() {
    this.globalLoading.next(false);
  }

  enableIsLeadGenerationStep(){
    this.isLeadGenerationStep.next(true);
  }
  disableIsLeadGenerationStep(){
    this.isLeadGenerationStep.next(false);
  }

  // Session Token methods
  setSessionToken(token: string) {
    this.sessionToken = token;
  }

  getSessionToken(): string {
    return this.sessionToken;
  }

  // Project Short Name methods
  setProjectShortName(name: string) {
    this.projectShortName = name;
  }

  getProjectShortName(): string {
    return this.projectShortName;
  }

  // Project Settings methods
  setProjectSettings(settings: ProjectSettings) {
    this.projectSettings = settings;
  }

  getProjectSettings(): ProjectSettings | null {
    return this.projectSettings;
  }
}

